import { render, staticRenderFns } from "./modalbase.vue?vue&type=template&id=4871b734&"
var script = {}
import style0 from "./../assets/css/modalbase.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports